import React, { FC } from 'react'
import { Tooltip } from 'react-tooltip'
import { twJoin } from 'tailwind-merge'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tooltipId?: string
  tooltipText?: string
  initialClassName?: string
}

export const AiAssistantSidebarItemOptionBtn: FC<Props> = ({
  className = 'bg-v8-blue/10 ',
  children,
  tooltipId,
  tooltipText,
  initialClassName = 'min-h-8 min-w-8 flex items-center justify-center rounded-md transition ease-in-out duration-500',
  ...rest
}) => {
  return (
    <>
      <button
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipText}
        data-tooltip-place="top"
        className={twJoin(initialClassName, className)}
        {...rest}
      >
        {children}
      </button>

      {/* Tooltip */}
      <Tooltip id={tooltipId} delayShow={1000} />
    </>
  )
}
